import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=dd0031e0&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0031e0",
  null
  
)

export default component.exports